var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100px",
  height: "100px",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "providers/clever/icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "providers/clever/icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#436CF2",
  x: 0,
  y: 0,
  width: 100,
  height: 100
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.7461867,82 C34.5106772,82 21,67.942648 21,50.1757169 L21,50.0195241 C21,32.4087858 34.276388,18 53.2928615,18 C64.9682733,18 71.9579012,21.90482 77.6979866,27.566809 L69.0292862,37.4850519 C64.2654057,33.1507016 59.3843807,30.495424 53.2147651,30.495424 C42.7888957,30.495424 35.252593,39.1641245 35.252593,49.7852349 L35.252593,49.9804759 C35.252593,60.6015863 42.5936547,69.4264796 53.2147651,69.4264796 C60.2824893,69.4264796 64.6168395,66.6150092 69.4978646,62.1635143 L78.166565,70.9103112 C71.7626602,77.7437462 64.6949359,82 52.7461867,82",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.6fbbeefcbef115c3d857dd7ae3199855.svg";